import { render, staticRenderFns } from "./W8.vue?vue&type=template&id=78f04c5d&scoped=true&"
import script from "./W8.vue?vue&type=script&lang=js&"
export * from "./W8.vue?vue&type=script&lang=js&"
import style0 from "./W8.vue?vue&type=style&index=0&id=78f04c5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f04c5d",
  null
  
)

export default component.exports